const defaultLang = 'en';
const supportLangs = [defaultLang, 'cn', 'jp', 'ar', 'tc', 'fr', 'kr', 'ru', 'tr', 'de', 'pt', 'mn', 'es'];

export const getPathLang  = () =>   {
    const langReg = new RegExp("^/("+supportLangs.join("|")+")(/|$)")
    let lang = location.pathname.match(langReg)
    lang = lang ? lang[1] : defaultLang
    return lang
}

export default (callback) => {
    if (window.XMLHttpRequest) {
        var xhr = new XMLHttpRequest();
    } else { //IE6及其以下版本浏览器
        var xhr = new ActiveXObject('Microsoft.XMLHTTP');
    }

    xhr.onreadystatechange = () => {
        if (xhr.readyState == 4 && xhr.status === 200) {
            const result = JSON.parse(xhr.responseText);
            result?.data?.data?.manageTrackingCheckList?.length && callback?.(result?.data?.data);
        }
    }
    xhr.open("POST", "/api/revamp/getConsentMode/");
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.send(JSON.stringify({
        query: {
            locale: getPathLang()
        }
    }));  
}